class TC_PlayerFreeplayback {
    constructor (playerInstance) {
        this.player = playerInstance;
        this.isSafariDesktop = window.safari !== undefined;
    }

    freePlaybackNotification (switchedChannel = false, pageUnload = false) {
        let timestampParam = '';

        if (this.isSafariDesktop) {
            timestampParam = '?v=' + Math.round(+Date.now() / 7500);
        }

        if (this.player.playing && this.player.previousChannelID !== 0 && this.player.currentChannel.id !== 0 && switchedChannel) {
            $.post('https://api.' + window.CSITE.appDomain + '/v2/session' + timestampParam, {
                username: this.player.user.login,
                token: this.player.user.token,
                channel_id: parseInt(this.player.previousChannelID, 10)
            }).done(() => {
                if (this.isSafariDesktop) {
                    timestampParam += '001';
                }
                
                $.post('https://api.' + window.CSITE.appDomain + '/v2/session' + timestampParam, {
                    username: this.player.user.login,
                    token: this.player.user.token,
                    channel_id: parseInt(this.player.currentChannel.id, 10)
                }).done(() => {
                    setTimeout(function() {
                        $(document).trigger('playerSessionSaved');
                    }, 2000)
                });
            });

            return;
        }

        if (this.player.playing && this.player.currentChannel.id !== 0) {
            $.post('https://api.' + window.CSITE.appDomain + '/v2/session' + timestampParam, {
                username: this.player.user.login,
                token: this.player.user.token,
                channel_id: parseInt(this.player.currentChannel.id, 10)
            });
        }

        if (pageUnload === false) {
            clearTimeout(this.player.freePlaybackNotificationTimeout);
            
            this.player.freePlaybackNotificationTimeout = setTimeout(() => {
                this.freePlaybackNotification();
            }, Math.floor(Math.random() * (140 - 100 + 1) + 100) * 1000);
        }
    }
}
